import type { ApiWsInplant } from "../../../../../../api/wsInplants";
import { defineFormConfig } from "@src/components/business-form";

/** Значения формы создания ВЗН УП (расход). */
export interface WsInplantInsertFormValues {
    num: string;
    senderCode: number | null;
    receiverCode: number | null;
    leaveLabouringCode: number | null;
    leaveMoveDate: string;
    arrivalLabouringCode: number | null;
    arrivalMoveDate: string;
    notice: string;
}

export const wsInplantInsertFormConfig = defineFormConfig<WsInplantInsertFormValues, ApiWsInplant>({
    fields: {
        num: {
            type: "string",
            label: "Номер ВЗН",
            validation: { required: true, maxLength: 32 },
            map: "Num",
        },
        senderCode: {
            type: "number",
            nullable: true,
            label: "Отправитель",
            validation: { required: true },
            map: "Sender",
        },
        receiverCode: {
            type: "number",
            nullable: true,
            label: "Получатель",
            validation: { required: true },
            map: "Receiver",
        },
        leaveLabouringCode: {
            type: "number",
            nullable: true,
            label: "Выдал МОЛ",
            validation: { required: true },
            map: "LeaveLabouring",
        },
        leaveMoveDate: {
            type: "date",
            label: "Дата выдачи",
            validation: { required: true },
            map: "LeaveMoveDate",
        },
        arrivalLabouringCode: {
            type: "number",
            nullable: true,
            label: "Принял МОЛ",
            map: "ArrivalLabouring",
        },
        arrivalMoveDate: {
            type: "date",
            label: "Дата принятия",
            map: "ArrivalMoveDate",
        },
        notice: {
            type: "string",
            label: "Примечание",
            validation: { maxLength: 255 },
            map: "Notice",
        },
    },
    toDomainOverride: (_values, { auto }) => ({
        ...auto,
        Code: 0,
        DocDate: new Date().toISOString(),
        SenderSection: 0,
        ReceiverSection: 0,
        ArrivalLabouring: auto.ArrivalLabouring ?? 0,
        ArrivalMoveDate: auto.ArrivalMoveDate ?? "",
        Notice: auto.Notice ?? "",
        bo: { State: 0 },
    }),
});

/** Собирает полный {@link ApiWsInplant} из значений формы создания. */
export function wsInplantInsertToApi(values: WsInplantInsertFormValues): ApiWsInplant {
    const partial = wsInplantInsertFormConfig.toDomain(values);
    return {
        Code: partial.Code ?? 0,
        Num: partial.Num ?? "",
        DocDate: partial.DocDate ?? new Date().toISOString(),
        Sender: partial.Sender ?? 0,
        SenderSection: partial.SenderSection ?? 0,
        Receiver: partial.Receiver ?? 0,
        ReceiverSection: partial.ReceiverSection ?? 0,
        LeaveLabouring: partial.LeaveLabouring ?? 0,
        LeaveMoveDate: partial.LeaveMoveDate ?? "",
        ArrivalLabouring: partial.ArrivalLabouring ?? 0,
        ArrivalMoveDate: partial.ArrivalMoveDate ?? "",
        Notice: partial.Notice ?? "",
        bo: partial.bo ?? { State: 0 },
    };
}
